export const TransactionStatuses: any = {
  FINISHED: 'finished',
  SUCCESS: 'success',
  FAILED: 'failed',
  ORDER_CONFIRMATION: 'orderConfirmation',
  ORDER_APPROVED: 'orderApproved',
  WORK_ORDER_READY: 'workOrderReady',
  READY_FOR_DELIVERY: 'readyForDelivery',
  READY_FOR_COURIER: 'readyForCourier',
  IN_TRANSIT: 'inTransit',
  IN_STORE: 'inStore',
  CANCELED: 'canceled'
};

export const SHOW_P2P_MODAL_KEY = 'showP2PCancelModal';

export default TransactionStatuses;
